import React, { useEffect, useState } from "react";

import { useForm, Controller } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import { IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  LOG_MODULE_API_NAME,
  ServiceList,
  EXTENSION_IDENTIFIER,
  SHAREPOINT_CONN_NAME,
  WORKDRIVE_CONN_NAME,
} from "../../../config/serviceConstant";
import RootFolderSelection from "../../Service/Workdrive/RootFolderSelection/RootFolderSelection";
import * as OtherAPICalling from "../../../APICalling/Other";

// import { createCronJobOrg } from "../../../../APICalling/Other";
import SharepointRootFolderSelection from "../../Service/Sharepoint/SharepointRootFolderSelection/SharepointRootFolderSelection";

const warningMessage = `If you revoke it, all kinds of automation including WORKFLOWS, WIDGETS,
            BUTTONS , RELATED LIST and SETTINGS will be DISABLED`;
const ZOHO = window.ZOHO;

function CreateNewDeleteAttachmentSettingModal(props) {
  const {
    setReload,
    orgid,
    apikey,
    datacenterurl,
    datacenter,
    zapikey,
    zuid,
    createNewSettingOpen,
    handleRevokeClose,
  } = props;

  const [customViewList, setCustomViewList] = useState([]);
  const {
    register,
    getValues,
    setValue,
    resetField,
    control,
    handleSubmit,
    watch,
  } = useForm({
    defaultValues: {},
  });

  const onSubmit = async (data) => {
    let config = {
      data: {
        settingId: data?.settingId || "",
        settingSchema: data,
        showInRelatedList: false,
        moduleApiName: LOG_MODULE_API_NAME,
        settingType: "deleteAttachment",
      },
      orgid,
      apikey,
      datacenter,
      datacenterurl,
    };
    const upsertSettingResp = await OtherAPICalling.upsertSetting(config);

    // handleCreateSetting(data);

    const reqHeaders = {
      orgid,
      connname: EXTENSION_IDENTIFIER,
      apikey,
      datacenterurl,
    };
    const deleteCronData = {
      url:
        datacenterurl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__executedelete/actions/execute?auth_type=apikey&zapikey=" +
        zapikey,
      name: `${orgid}__${EXTENSION_IDENTIFIER}`,
      params: {},
      headers: reqHeaders,
      body: {},
      type: "GET",
      execute_in: 1,
    };
    const cronjobOrgResp = await OtherAPICalling.createCronJobOrg(
      deleteCronData,
      reqHeaders
    );

    setReload((prev) => !prev);
  };
  // `${orgid}__${EXTENSION_IDENTIFIER}`

  useEffect(() => {
    async function fetchLogModuleViews() {
      try {
        const customViewResp = await ZOHO.CRM.META.getCustomViews({
          Entity: LOG_MODULE_API_NAME,
        });
        const customViews = customViewResp?.custom_views?.map((cv) => {
          return { displayLabel: cv?.name, id: cv?.id };
        });
        setCustomViewList((prev) => customViews);
      } catch (error) {}
    }
    fetchLogModuleViews();
  }, []);

  return (
    <>
      {/* <Button variant="contained" onClick={handleClickNewSettingOpen}>
        Create Setting
      </Button> */}

      <Dialog
        open={createNewSettingOpen}
        onClose={handleRevokeClose}
        aria-labelledby="alert-dialog-title"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 2,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            pb: 1,
          }}
        >
          New Setting
          <IconButton
            onClick={handleRevokeClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            pt: 2,
            borderBottom: "none",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Delete Setting Name Field */}
            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 0.5 }}>
              Delete Setting Name <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  placeholder="Give delete attachment name"
                  required
                  size="small"
                  sx={{ mb: 1 }}
                />
              )}
            />
            <Typography
              variant="caption"
              sx={{ mb: 2, display: "block", color: "text.secondary" }}
            >
              Give this delete rule a name to help you identify it (e.g., “Old
              Invoices”, “Closed Deals Cleanup”).
            </Typography>

            {/* Custom View Field */}
            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 0.5 }}>
              Custom View <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="sheduleDeleteViewAttachment"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  autoHighlight
                  size="small"
                  options={customViewList}
                  disableClearable
                  getOptionLabel={(option) => option?.displayLabel}
                  onChange={(e, value) => field.onChange(value)}
                  value={field?.value}
                  required
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select view" required />
                  )}
                  sx={{ mb: 1 }}
                />
              )}
            />
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", mb: 2, display: "block" }}
            >
              Select the custom view from the ‘Attachment Log’ module to apply
              this setting. Ensure that the chosen custom view includes the
              conditions outlined in the warning section.
            </Typography>

            {/* Action Buttons */}
            <DialogActions sx={{ px: 0, mt: 2 }}>
              <Button
                onClick={handleRevokeClose}
                variant="outlined"
                color="primary"
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default CreateNewDeleteAttachmentSettingModal;
